<button class="buttonleft" (click)="toggleDrawer()">
    Brand Search
</button>

<div class="drawer-container">
    <div class="drawer" [class.open]="isDrawerOpen">
        <div style="text-align: right;" class="close-button-container">
            <button class="close-button" style="margin-right: 8px;" (click)="clearBrand()">Clear</button>
            <button class="close-button" (click)="closeDrawer()">Close</button>
        </div>
        <h3 class="headercat" style="padding-left:18px;">Brands</h3>
        <div class="containersmall">
            <div *ngIf="isDrawerOpen" class="row brand-list">
                <a *ngFor="let brand of brands" class="col-md-4 col-xs-4">
                    <div (click)="filterByBrand(brand.name); closeDrawer()" class="product-aside">
                        <a href="{{currentUrl}}?brandFilter={{brand.name}}" (click)="onClick($event)"
                            class="product-img-aside">
                            <div class="image-container">
                                <!-- <img class="img-fluid brand" src="{{brand.imageUrl}}" alt="" /> -->
                                <app-product-image [imageUrl]="brand.imageUrl" [brandImage]="true"></app-product-image>
                            </div>
                        </a>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="underlay" [class.open]="isDrawerOpen" (click)="closeDrawer()"></div>
    <div class="black-background" [class.open]="isDrawerOpen" (click)="closeDrawer()"></div>
</div>
